import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/coupon"

export const getCoupens = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getCoupen = async couponId => {
  const response = await farasod.get(`${endpoint}/${couponId}`)

  return response.data
}

export const getCombos = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/public/comboset/all?${query}`)

  return response.data
}

export const addCoupen = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editCoupen = async (coupenId, data) => {
  const response = await farasod.patch(`${endpoint}/${coupenId}`, data)

  return response.data
}

export const deleteCoupen = async coupenId => {
  const response = await farasod.delete(`${endpoint}/${coupenId}`)

  return response.data
}

export const getCouponReports = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )
  const response = await farasod.get(`${endpoint}/report/used?${query}`)

  return response.data
}

export const getCoupenHistory = async coupenId => {
  const response = await farasod.get(`${endpoint}/${coupenId}/usage`)

  return response.data
}

export const changeCouponStatus = async (couponId, isActive, isPublic) => {
  const response =
    await farasod.patch(`${endpoint}/${couponId}/status`, {
      isActive,
      isPublic
    })

  return response.data
}

export const setCouponUserList = async (couponId, editType, users) => {
  const response = await farasod.patch(`${endpoint}/${couponId}/userList/${editType}`, {
    users
  })

  return response.data
}

export const addUserToCoupon = async (data) => {
  const response = await farasod.patch(`${endpoint}/add/user`, data)

  return response.data
}

export const removeUserFromCoupon = async (data) => {
  const response = await farasod.patch(`${endpoint}/remove/user`, data)

  return response.data
}